<template>
  <v-container>
    <h1 v-if="id > 0">Modification de la demande #{{ id }}</h1>
    <h1 v-else>Nouvelle demande</h1>
    <demande-main></demande-main>
  </v-container>
</template>

<script>
import FournisseurService from "@/services/FournisseurService";
import DemandesService from "@/services/DemandeService";
import store from "@/store/index";
import DemandeMain from "@/components/DemandeMain";

export default {
  name: "DemandeView",
  components: {
    DemandeMain,
  },
  props: {
    id: {
      type: Number,
      required: false,
    },
  },

  // computed: {
  //   demande() {
  //     return this.$store.state.demandeEditee.demande;
  //   },
  //   produit() {
  //     return this.$store.state.demandeEditee.produit;
  //   },
  // },

  beforeRouteEnter(to, from, next) {
    store.dispatch("demandeEditee/setDemandeEnCours", null);
    store.dispatch("demandeEditee/setProduitDemandeEnCours", null);
    let id = to.params.id;
    // console.log("to", to);
    // console.log("id", id);
    if (id) {
      //Demande existante
      store.dispatch("startLoading");
      FournisseurService.getDemande(id)
        .then((res) => {
          let demande = res.data;
          store.dispatch("demandeEditee/setDemandeEnCours", demande);
          //Obtention du produit lié à la demande
          //let idProduit =  ? demande.idProduit : null;
          //console.log(demande.type);
          if (demande.typeNum != 4) {
            //console.log("idProduit", idProduit);
            FournisseurService.getProduitDemande(demande.id)
              .then((resPdt) => {
                let produit = resPdt.data;
                // Eclatement des images en plusieurs tableaux
                produit.imagesReferences = [];
                produit.imagesDescription = [];
                let removeImgIndexes = [];
                produit.images.forEach((img, index) => {
                  if (img.position == "references") {
                    produit.imagesReferences.push(img);
                    removeImgIndexes.unshift(index);
                  } else if (img.position == "description") {
                    produit.imagesDescription.push(img);
                    removeImgIndexes.unshift(index);
                  }
                });
                removeImgIndexes.forEach((index) => {
                  produit.images.splice(index, 1);
                });
                store.dispatch(
                  "demandeEditee/setProduitDemandeEnCours",
                  produit
                );
                store.dispatch("stopLoading");
                next();
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.status &&
                  err.response.status == 404
                ) {
                  this.$store.dispatch(
                    "setErreur",
                    new Error(
                      "Le produit associé à la demande n'a pas pu être récupéré sur le serveur d'Europharmat. Merci de contacter l'équipe d'Europharmat."
                    )
                  );
                } else {
                  let errorToPropagate = new Error();
                  if (err instanceof Error) {
                    errorToPropagate.originalError = err;
                  } else {
                    errorToPropagate.message =
                      "Une erreur inconnnue s'est produite pendant la récupération du produit de la demande. Merci de contacter l'équipe d'Europharmat.";
                  }
                  next(errorToPropagate);
                }
              });
          } else {
            next();
          }
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            next({ name: "home" });
          } else {
            // console.log("About to call next(err)");
            let errorToPropagate = new Error();
            errorToPropagate.originalError = err;
            next(errorToPropagate);
          }
        });
    } else {
      // Nouvelle demande
      store.dispatch("demandeEditee/setProduitDemandeEnCours", null);
      store.dispatch("demandeEditee/setDemandeEnCours", null);

      next(() => {
        Promise.all([
          DemandesService.getTypes(),
          FournisseurService.getProduits(),
        ])
          .then((results) => {
            // console.log(results);
            let typesDemandes = results[0].data.filter(
              (type) => type.valeur != 2
            );
            let produitsFrn = results[1].data;

            store.dispatch("demandeEditee/setTypesDemandes", typesDemandes);
            store.dispatch("demandeEditee/setProduitsFournisseur", produitsFrn);
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.status &&
              err.response.status == 401
            ) {
              next({ name: "home" });
            } else {
              let errorToPropagate = new Error();
              if (err instanceof Error) {
                errorToPropagate.originalError = err;
              }
              next(errorToPropagate);
            }
          });
      });
    }
  },
};
</script>

<style></style>
